import React from 'react'
import { Paper, Typography  } from '@material-ui/core';

function Property(){
    return(
        <div>
            <Paper>
                <Typography>
                    Property
                </Typography>
            </Paper>
        </div>
    );
}

export default Property
